import LessonNoteAPI from '@/apis/business/student/lesson-note.js'
export default {
  namespaced: true,
  state: {
    noteContent: '', // Nội dung ghi chú
    currentTime: '', // Thời gian xem video hiện tại
    nameLesson: '', // Tên bài giảng
    lessonNote: [], // Ghi chú
    videoActive: {}// video đang được chọn
  },

  getters: {
  },

  mutations: {
    setNoteContent (state, noteContent) {
      state.noteContent = noteContent
    },
    setCurrentTime (state, currentTime) {
      state.currentTime = currentTime
    },
    setNameLesson (state, nameLesson) {
      state.nameLesson = nameLesson
    },
    setLessonNote (state, lessonNote) {
      state.lessonNote = lessonNote
    },
    setVideoActive (state, videoActive) {
      state.videoActive = videoActive
    }
  },

  actions: {

    addLessonNote (store, note) {
      return new Promise((resolve, reject) => {
        LessonNoteAPI.postAsync('lesson-note', note)
          .then((res) => {
            store.dispatch('getLessonNote', note.LessonID)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getLessonNote (context, lessonID) {
      return new Promise((resolve, reject) => {
        LessonNoteAPI.getAsync(`lesson-note/${lessonID}`)
          .then((res) => {
            const noteList = Object.values(res.Data.reduce((acc, item) => {
            // Append the item to the array for each country
              acc[item.VideoID] = [...(acc[item.VideoID] || []), item]
              return acc
            }, {}))
            context.commit('setLessonNote', noteList)

            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    deleteLessonNote (store, data) {
      return new Promise((resolve, reject) => {
        LessonNoteAPI.deleteAsync(`lesson-note/${data.IdNote}`)
          .then((res) => {
            store.dispatch('getLessonNote', data.LessonID)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
